import type { ReactNode } from 'react'
import { useState } from 'react'
import CentralModal from '../CentralModal/CentralModal'
import classes from './ConfirmationDialog.module.scss'

export interface Props {
  children: ReactNode
  timeoutMS?: number
}

const ConfirmationDialog = ({
  children,
  timeoutMS = 3000
}: Props) => {
  // Initially set the dialog to be open
  const [isOpen, setIsOpen] = useState(true)

  const closeModal = () => {
    setIsOpen(false)
  }

  // When the timeout elapses, automatically close the dialog
  setTimeout(closeModal, timeoutMS)

  return (
    <CentralModal
      isOpen={isOpen}
      label='Confirm'
      onRequestClose={closeModal}
    >
      <div className={classes.ConfirmationDialog}>
        {children}
      </div>
    </CentralModal>
  )
}

export default ConfirmationDialog
